import { axios } from "@/plugins/axios";
import { getDataString } from "@/utils";
import store from "../store";

function getFlexibleLife(contractId) {
    return axios.post(
        "?Mode=MeinServicebereich&Function=GetFlexibleLife",
        "vertragsnummer=" + contractId
    );
}

function getFlexibleLife20(contractId) {
    return axios.post(
        "?Mode=MeinServicebereich&Function=GetFlexibleLife20",
        "vertragsnummer=" + contractId
    );
}

function changeFlexibleLife(data = {}) {
    // Gesamt
    const { vertragsnummer } = data;

    // // Anpassen
    // const {
    //     vertragsnummer,
    //     mtan,
    //     verifymtan,
    //     reswitch,
    //     klassischpercent,
    //     fonds1percent,
    //     fonds2percent,
    //     fonds7percent,
    //     fonds3percent,
    //     fonds4percent,
    //     fonds5percent,
    //     fonds6percent,
    //     methode,
    //     agb1,
    //     agb2,
    //     risikochecked,
    //     simulate,
    //     sendemail
    // } = data;

    // // Einzahlung Einmalig
    // const {
    //     vertragsnummer,
    //     mtan,
    //     verifymtan,
    //     reswitch,
    //     klassischzuzahlung,
    //     fonds1zuzahlung,
    //     fonds2zuzahlung,
    //     fonds7zuzahlung,
    //     fonds3zuzahlung,
    //     fonds4zuzahlung,
    //     fonds5zuzahlung,
    //     fonds6zuzahlung,
    //     klassischpercent,
    //     fonds1percent,
    //     fonds2percent,
    //     fonds7percent,
    //     fonds3percent,
    //     fonds4percent,
    //     fonds5percent,
    //     fonds6percent,
    //     methode,
    //     agb1,
    //     agb2,
    //     risikochecked
    // } = data;

    // // Einzahlung Monatlich
    // const {
    //     vertragsnummer,
    //     betrag,
    //     methode,
    //     mtan,
    //     verifymtan,
    //     simulate
    // } = data;

    // // Auszahlung
    // const {
    //     vertragsnummer,
    //     mtan,
    //     verifymtan,
    //     klassischteilentnahme,
    //     fonds1teilentnahme,
    //     fonds2teilentnahme,
    //     fonds7teilentnahme,
    //     fonds3teilentnahme,
    //     fonds4teilentnahme,
    //     fonds5teilentnahme,
    //     fonds6teilentnahme,
    //     methode,
    //     simulate
    // } = data;

    const dataString = getDataString(data);
    return new Promise((resolve) => {
        axios
            .post(
                "?Mode=MeinServicebereich&Function=ChangeFlexibleLife",
                dataString
            )
            .then((response) => {
                if (
                    response.data.Status === 200 &&
                    Object.keys(response.data.Result).length === 0
                ) {
                    store.cache.delete(
                        "flexiblelife/getFlexibleLife",
                        vertragsnummer
                    );
                    store.commit("flexiblelife/setFlexibleLife", {
                        contractId: vertragsnummer,
                        flexiblelife: {},
                    });
                }
                resolve(response);
            });
    });
}

function changeFlexibleLife20(data = {}) {
    const { vertragsnummer } = data;
    const dataString = getDataString(data);
    return new Promise((resolve) => {
        axios
            .post(
                "?Mode=MeinServicebereich&Function=ChangeFlexibleLife20",
                dataString
            )
            .then((response) => {
                if (
                    response.data.Status === 200 &&
                    Object.keys(response.data.Result).length === 0
                ) {
                    store.cache.delete(
                        "flexiblelife/getFlexibleLife20",
                        vertragsnummer
                    );
                    store.commit("flexiblelife/setFlexibleLife", {
                        contractId: vertragsnummer,
                        flexiblelife: {},
                    });
                }
                resolve(response);
            });
    });
}

export {
    getFlexibleLife,
    getFlexibleLife20,
    changeFlexibleLife,
    changeFlexibleLife20,
};
